import { GlobalToken, Divider } from 'antd';
import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  .ant-select {
    width: 100%;
  }

  .option-container {
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  .station-name-container {
    flex: 1;
    min-width: 0;
    text-align: left;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: ${({ theme: { token } }) => token.marginXXS}px 0;
`;

export const ButtonContainer = styled.div`
  text-align: center;
  width: 100%;
  .create-site-button {
    color: ${({ theme }) => theme.token.colorPrimary};
    text-align: center;
    &.ant-btn:hover {
      color: ${({ theme }) => theme.token.colorPrimary};
    }
  }
`;

export const SelectPrefixStyle = createGlobalStyle`
  .eco-select-station-popup .opt-prefix {
      text-align: left;
      white-space: nowrap;
      min-width: 2.3rem;
      color: ${({ theme }) => theme.token.colorTextTertiary};
  }

  .eco-select-station-popup .option-container {
      display: flex;
      text-align: left;
      align-items: flex-start;
  }
`;
